import { toast } from "sonner";
import { errMsg, useApi } from "../../lib/api";

const Person = ({ p, action }) => (
  <li className="flex items-center justify-between gap-2 py-1.5" data-testid={`person-${p.user_id}`}>
    <span className="flex items-center gap-2 text-sm min-w-0">
      <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-[#39ff6a] glow-green" />
      <span className="truncate">{p.name}</span>
      {p.role !== "student" && <span className="mono text-[9px] uppercase text-pink-300">{p.role}</span>}
    </span>
    {action}
  </li>
);

export const PeoplePanel = ({ state, refresh }) => {
  const api = useApi();
  const { people, me, invites, kind, space } = state;
  const call = async (path, user_id) => {
    try { await api.post(`/rooms/${space.id}/stage/${path}`, { user_id }); refresh(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  const stage = people.filter((p) => p.on_stage);
  const audience = people.filter((p) => !p.on_stage);
  const btn = "mono text-[10px] uppercase rounded-[2px] border px-2 py-0.5 transition-colors";
  return (
    <div className="space-y-5" data-testid="people-panel">
      <div>
        <p className="mono-label mb-1">{kind === "room" ? "On stage" : "In the lesson"} · {stage.length}</p>
        <ul>{stage.map((p) => (
          <Person key={p.user_id} p={p} action={kind === "room" && me.can_control && p.user_id !== me.user_id && (
            <button className={`${btn} border-zinc-700 text-zinc-400 hover:text-white`} data-testid={`send-back-btn-${p.user_id}`} onClick={() => call("remove", p.user_id)}>Send back</button>
          )} />
        ))}</ul>
      </div>
      {kind === "room" && (
        <div>
          <p className="mono-label mb-1">Audience · {audience.length}</p>
          <ul>{audience.map((p) => (
            <Person key={p.user_id} p={p} action={me.can_control && (
              invites.includes(p.user_id)
                ? <span className="mono text-[10px] text-pink-300">Invited</span>
                : <button className={`${btn} border-pink-500/60 text-pink-300 hover:bg-pink-500/15`} data-testid={`invite-stage-btn-${p.user_id}`} onClick={() => call("invite", p.user_id)}>Invite up</button>
            )} />
          ))}</ul>
          {audience.length === 0 && <p className="text-sm text-zinc-500">Nobody in the seats yet.</p>}
        </div>
      )}
    </div>
  );
};
